import { Link } from 'react-router-dom';
import { clinicInfo, specialties, navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/60">
      {/* Main Footer */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-3xl tracking-[0.12em] text-foreground-950">
                Femme<span className="font-light italic">Vie</span>
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-xs mt-4">
              Clínica boutique de saúde feminina. Cuidando da mulher em todas as fases da vida com excelência, tecnologia e acolhimento.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href={clinicInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-all duration-300"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href={`https://wa.me/${clinicInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-all duration-300"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Links Column 1 */}
          <div className="lg:col-span-2">
            <h4 className="font-label text-xs tracking-[0.12em] uppercase text-foreground-400 mb-5 whitespace-nowrap">
              Navegação
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Links Column 2 */}
          <div className="lg:col-span-3">
            <h4 className="font-label text-xs tracking-[0.12em] uppercase text-foreground-400 mb-5 whitespace-nowrap">
              Especialidades
            </h4>
            <ul className="space-y-3">
              {specialties.slice(0, 6).map((spec) => (
                <li key={spec.id}>
                  <Link
                    to="/especialidades"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {spec.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div className="lg:col-span-3">
            <h4 className="font-label text-xs tracking-[0.12em] uppercase text-foreground-400 mb-5 whitespace-nowrap">
              Contato
            </h4>
            <div className="space-y-3 text-sm text-foreground-600">
              <p>
                <a
                  href={`https://wa.me/${clinicInfo.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line mr-2 text-primary-500"></i>
                  (85) 9 8429-3412
                </a>
              </p>
              <p>
                <a href={`tel:${clinicInfo.phone.replace(/\D/g, '')}`} className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  <i className="ri-phone-line mr-2 text-primary-500"></i>
                  {clinicInfo.phone}
                </a>
              </p>
              <p>
                <i className="ri-map-pin-line mr-2 text-primary-500"></i>
                {clinicInfo.address.street}
              </p>
              <p className="ml-6 text-xs text-foreground-500">
                {clinicInfo.address.complement}<br />
                {clinicInfo.address.neighborhood} - {clinicInfo.address.city}/{clinicInfo.address.state}
              </p>
              <p>
                <i className="ri-time-line mr-2 text-primary-500"></i>
                {clinicInfo.hours}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-300/60">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; {new Date().getFullYear()} Femme Vie. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/politica-privacidade" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Política de Privacidade
            </Link>
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              CRM-CE 14200 / 14202
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}